import React, { useState, useEffect, useContext } from "react";
import Sidebar from "../components/Sidebar/Sidebar";
import Navbar from "../components/Navbars/IndexNavbar";
import { AuthContext } from "../context/AuthContext";

export default function AdminLayout({ children }) {
  const { user } = useContext(AuthContext);
  const nombreUsuario = user?.nombre || "Usuario";

  const [collapsed, setCollapsed] = useState(
    JSON.parse(localStorage.getItem("sidebarCollapsed")) ?? true
  );

  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", collapsed);
    // (2026-05-15) Expone el estado del sidebar al <body> para que el CSS
    // global desplace dinamicamente las modales (`fixed inset-0 z-50`) y
    // queden centradas en el area de contenido (a la derecha del sidebar),
    // re-centrandose al colapsar/expandir. Se limpia al desmontar el layout
    // para que las vistas publicas (login) no hereden el offset.
    document.body.setAttribute("data-sidebar", collapsed ? "collapsed" : "expanded");
    return () => document.body.removeAttribute("data-sidebar");
  }, [collapsed]);

  return (
    <div className="relative flex min-h-screen overflow-x-hidden" style={{ background: "#f5f6fb" }}>
      {/* Decoración radial sutil de fondo */}
      <div
        className="pointer-events-none fixed inset-0 z-0"
        style={{
          background:
            "radial-gradient(900px 500px at 100% 0%, rgba(69,81,247,0.08), transparent 60%), radial-gradient(800px 500px at 0% 100%, rgba(48,57,172,0.06), transparent 60%)",
        }}
      />

      {/* Sidebar */}
      <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

      {/* Contenido principal */}
      <div
        className={`
          relative z-10 flex flex-col flex-1 min-w-0
          transition-all duration-300 ease-in-out
          ${collapsed ? "md:pl-20" : "md:pl-72"}
          min-h-screen
        `}
      >
        {/* Navbar */}
        <Navbar
          nombreUsuario={nombreUsuario}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />

        {/* Main */}
        <main className="flex-1 w-full overflow-y-auto">
          <div className="max-w-[1600px] mx-auto p-4 md:p-6 lg:p-8 animate-sirius-fade-up">
            {React.Children.map(children, (child) =>
              React.isValidElement(child)
                ? React.cloneElement(child, { collapsed })
                : child
            )}
          </div>

          {/* Footer */}
          <footer className="max-w-[1600px] mx-auto px-4 md:px-8 pb-6 pt-2">
            <div className="h-px w-full bg-gradient-to-r from-transparent via-sirius-200 to-transparent mb-4" />
            <div className="flex flex-col md:flex-row items-center justify-between gap-1 text-center md:text-left">
              <p className="text-ink-500 text-xs">
                © {new Date().getFullYear()}{" "}
                <span className="font-display font-semibold text-sirius-700">Sirius Solutions</span>
                {" "}— Quantus Invoice v{process.env.REACT_APP_VERSION || "2.0"}
              </p>
              <p className="text-ink-400 text-xs italic">
                Iluminando el futuro con soluciones inteligentes.
              </p>
            </div>
          </footer>
        </main>
      </div>
    </div>
  );
}